import { Modelo } from "../interfaces/modelo";
import imgCabañas01 from "../media/img/proyectos/cabanas/Portada.webp";
import imgCabañas02 from "../media/img/proyectos/cabanas/4cd02e4c-4849-4bf6-b487-636a6e8dd331.webp";
import imgCabañas03 from "../media/img/proyectos/cabanas/9cf1b0d6-b403-43db-8c56-161150b9df7b.webp";
import imgCabañas04 from "../media/img/proyectos/cabanas/45a4d977-9721-4dd2-a184-3473f89f5c51.webp";
import imgCabañas05 from "../media/img/proyectos/cabanas/461b5824-541c-4f60-8b39-a8d56a31d981.webp";
import imgCabañas06 from "../media/img/proyectos/cabanas/captura de pantalla (65).webp";
import imgCabañas07 from "../media/img/proyectos/cabanas/captura de pantalla (71).webp";
import imgCabañas08 from "../media/img/proyectos/cabanas/dji_0909.webp";
import imgCabañas09 from "../media/img/proyectos/cabanas/f925154b-7886-4dcf-88da-f82f348cfe93.webp";
import imgCabañas10 from "../media/img/proyectos/cabanas/IMG_0090.webp";

import imgG2801 from "../media/img/modelos/g28/1.webp";
import imgG2802 from "../media/img/modelos/g28/2.webp";
import imgG2803 from "../media/img/modelos/g28/3.webp";
import imgG2804 from "../media/img/modelos/g28/4.webp";
import imgG2805 from "../media/img/modelos/g28/5.webp";
import imgG2806 from "../media/img/modelos/g28/6.webp";

import imgMatheu01 from "../media/img/proyectos/matheu/Portada.jpeg";
import imgMatheu02 from "../media/img/proyectos/matheu/Converted_WebP/33.webp";
import imgMatheu03 from "../media/img/proyectos/matheu/Converted_WebP/34.webp";
import imgMatheu04 from "../media/img/proyectos/matheu/Converted_WebP/captura de pantalla (80).webp";
import imgMatheu05 from "../media/img/proyectos/matheu/IMG_8358.jpg";
import imgMatheu06 from "../media/img/proyectos/matheu/IMG_8364.jpg";
import imgMatheu07 from "../media/img/proyectos/matheu/IMG_8386.jpg";
import imgMatheu08 from "../media/img/proyectos/matheu/Converted_WebP/img_8453.webp";
import imgMatheu09 from "../media/img/proyectos/matheu/Converted_WebP/img_8456.webp";
import imgMatheu10 from "../media/img/proyectos/matheu/Converted_WebP/img_8458.webp";
import imgMatheu11 from "../media/img/proyectos/matheu/Converted_WebP/img_8462.webp";
import imgMatheu12 from "../media/img/proyectos/matheu/Converted_WebP/IMG_0835.webp";
import imgMatheu13 from "../media/img/proyectos/matheu/Converted_WebP/IMG_5610.webp";

import imgGuest01 from "../media/img/proyectos/guest/Portada.jpg";
import imgGuest02 from "../media/img/proyectos/guest/Converted_WebP/64.webp";
import imgGuest03 from "../media/img/proyectos/guest/Converted_WebP/8ed3577b-a5bb-4b9c-a134-65a4eac629f2.webp";
import imgGuest04 from "../media/img/proyectos/guest/Converted_WebP/bycairo-15 (1).webp";
import imgGuest05 from "../media/img/proyectos/guest/Converted_WebP/bycairo-15.webp";
import imgGuest06 from "../media/img/proyectos/guest/Converted_WebP/bycairo-21.webp";
import imgGuest07 from "../media/img/proyectos/guest/Converted_WebP/bycairo-22.webp";
import imgGuest08 from "../media/img/proyectos/guest/Converted_WebP/bycairo-36.webp";
import imgGuest09 from "../media/img/proyectos/guest/Converted_WebP/bycairo-43.webp";
import imgGuest10 from "../media/img/proyectos/guest/Converted_WebP/bycairo-7.webp";
import imgGuest11 from "../media/img/proyectos/guest/Converted_WebP/bycairo-9.webp";
import imgGuest12 from "../media/img/proyectos/guest/Converted_WebP/IMG_5611.webp";
import imgGuest13 from "../media/img/proyectos/guest/Converted_WebP/IMG_5616.webp";

import imgSueño01 from "../media/img/proyectos/suenojoven/Portada.jpg";
import imgSueño02 from "../media/img/proyectos/suenojoven/14.jpg";
import imgSueño03 from "../media/img/proyectos/suenojoven/5f27af21-1fb2-4d45-9b3f-587e9dd80240.jpg";
import imgSueño04 from "../media/img/proyectos/suenojoven/717cf03a-c1bb-4885-b236-db2686fc01a5.jpg";
import imgSueño05 from "../media/img/proyectos/suenojoven/BYCAIRO-11.jpg";
import imgSueño06 from "../media/img/proyectos/suenojoven/chapa close up.jpg";
import imgSueño07 from "../media/img/proyectos/suenojoven/Converted_WebP/foto-22.webp";
import imgSueño08 from "../media/img/proyectos/suenojoven/Image1.png";
import imgSueño09 from "../media/img/proyectos/suenojoven/Image9.png";
import imgSueño10 from "../media/img/proyectos/suenojoven/IMG_5240.jpg";
import imgSueño11 from "../media/img/proyectos/suenojoven/IMG_5244.jpg";
import imgSueño12 from "../media/img/proyectos/suenojoven/undor drop igfoto2.jpg";

import imgVino01 from "../media/img/proyectos/vinoandino/Portada.jpg";
import imgVino02 from "../media/img/proyectos/vinoandino/2d9fb1d5-e0b7-4b6d-922c-83bd9041f5ab (1).jpg";
import imgVino03 from "../media/img/proyectos/vinoandino/4 (1).jpg";
import imgVino04 from "../media/img/proyectos/vinoandino/4b3d2c9d-697d-4977-8829-431303c2855f.jpg";
import imgVino05 from "../media/img/proyectos/vinoandino/52b96d90-7ddb-48e5-a45a-4a0b753682ef.jpg";
import imgVino06 from "../media/img/proyectos/vinoandino/7c11eaaf-2f2f-40d0-aa40-f628ce301d5d.jpg";
import imgVino07 from "../media/img/proyectos/vinoandino/87aa112e-9cfb-464b-be07-e58b87c76143.jpg";
import imgVino08 from "../media/img/proyectos/vinoandino/8c9caebc-a28d-43e6-98f2-92470de73907 (2).jpg";
import imgVino09 from "../media/img/proyectos/vinoandino/8ed3577b-a5bb-4b9c-a134-65a4eac629f2.jpg";
import imgVino10 from "../media/img/proyectos/vinoandino/98fea38b-4897-418d-a5a9-2fc85b3d6b16-1.jpg";
import imgVino11 from "../media/img/proyectos/vinoandino/Captura de pantalla (85).png";
import imgVino12 from "../media/img/proyectos/vinoandino/3907ae4c-6d1d-4ae8-927f-fa836a5ec892.webp";
import imgVino13 from "../media/img/proyectos/vinoandino/da03a9fe-4ee6-4fa3-86c6-50c87a6ef2e7.webp";
import imgVino14 from "../media/img/proyectos/vinoandino/IMG_0222.jpeg";
import imgVino15 from "../media/img/proyectos/vinoandino/WhatsApp Image 2023-02-08 at 15.41.01 (1).jpeg";
import imgVino16 from "../media/img/proyectos/vinoandino/WhatsApp Image 2023-02-08 at 15.57.59.jpeg";
import imgVino17 from "../media/img/proyectos/vinoandino/e393088d-b5af-4d67-859e-b88f1f3406e6.jpg";
import imgVino18 from "../media/img/proyectos/vinoandino/e7ca5494-a19e-40cd-a991-6dc85826e3c5.jpg";
import imgVino19 from "../media/img/proyectos/vinoandino/fb33ef6e-093b-402c-9602-e559ae534045.jpg";
import imgVino20 from "../media/img/proyectos/vinoandino/IMG_0235.webp";

import imgGala01 from "../media/img/proyectos/gala/IMG_7092.webp";
import imgGala02 from "../media/img/proyectos/gala/0f56c5b8-c772-4b9f-b42d-85005ec4280f.webp";
import imgGala03 from "../media/img/proyectos/gala/9f32b56e-3452-44bf-af0e-2398a1aeaba7.webp";
import imgGala04 from "../media/img/proyectos/gala/39f82b2f-4823-4494-a958-1e6ee7e91888.webp";
import imgGala05 from "../media/img/proyectos/gala/cacca846-a4f3-4caf-8c92-99de793822fa.webp";
import imgGala06 from "../media/img/proyectos/gala/eeeb6d40-915b-47bf-9421-604c1159555d.webp";
import imgGala07 from "../media/img/proyectos/gala/AREF.webp";
import imgGala08 from "../media/img/proyectos/gala/IMG_7112.webp";

import imgCasaCanario01 from "../media/img/proyectos/casacanario/CARATULA.webp";
import imgCasaCanario02 from "../media/img/proyectos/casacanario/10.webp";
import imgCasaCanario03 from "../media/img/proyectos/casacanario/Imagen de WhatsApp 2025-04-01 a las 10.20.20_e1b704df.webp";
import imgCasaCanario04 from "../media/img/proyectos/casacanario/Imagen de WhatsApp 2025-04-01 a las 10.20.21_73fc4737.webp";
import imgCasaCanario05 from "../media/img/proyectos/casacanario/IMG_1464.webp";
import imgCasaCanario06 from "../media/img/proyectos/casacanario/IMG_1470.webp";
import imgCasaCanario07 from "../media/img/proyectos/casacanario/IMG_2731.webp";
import imgCasaCanario08 from "../media/img/proyectos/casacanario/IMG_2820(1).webp";
import imgCasaCanario09 from "../media/img/proyectos/casacanario/IMG_2820.webp";

import imgHeadQuarter01 from "../media/img/proyectos/headquarter/IMG_4508.webp";
import imgHeadQuarter02 from "../media/img/proyectos/headquarter/IMG_0729.webp";
import imgHeadQuarter03 from "../media/img/proyectos/headquarter/IMG_0910.webp";
import imgHeadQuarter04 from "../media/img/proyectos/headquarter/IMG_0912.webp";
import imgHeadQuarter05 from "../media/img/proyectos/headquarter/IMG_0916.webp";
import imgHeadQuarter06 from "../media/img/proyectos/headquarter/IMG_0921.webp";
import imgHeadQuarter07 from "../media/img/proyectos/headquarter/IMG_0941.webp";
import imgHeadQuarter08 from "../media/img/proyectos/headquarter/IMG_0237.webp";

import imgCasaRio01 from "../media/img/proyectos/casarioii/Foto 1.webp";
import imgCasaRio02 from "../media/img/proyectos/casarioii/Foto 2.webp";
import imgCasaRio03 from "../media/img/proyectos/casarioii/Foto 3.webp";
import imgCasaRio04 from "../media/img/proyectos/casarioii/Foto 4.webp";
import imgCasaRio05 from "../media/img/proyectos/casarioii/Foto 5.webp";
import imgCasaRio06 from "../media/img/proyectos/casarioii/Foto 6.webp";
import imgCasaRio07 from "../media/img/proyectos/casarioii/Foto 7.webp";
import imgCasaRio08 from "../media/img/proyectos/casarioii/Foto 8.webp";
import imgCasaRio09 from "../media/img/proyectos/casarioii/Foto 9.webp";

export const MockProyectos: Modelo[] = [
    {
        id: 1,
        nombre: 'Casa G28',
        subtitulo: '',
        descripcion: `Ubicación: Gorina
        Ejecución: 3 meses`,
        valor: 0,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 0, descripcion: '' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgG2801 }, { id: 2, nombre: 'Imagen02', url: imgG2802 }, { id: 3, nombre: 'Imagen03', url: imgG2803 }, { id: 4, nombre: 'Imagen04', url: imgG2804 },
        { id: 5, nombre: 'Imagen05', url: imgG2805 }, { id: 6, nombre: 'Imagen06', url: imgG2806 }],
        caracteristicas: [{ id: 1, descripcion: '2 dormitorios | 6 módulos' }, { id: 2, descripcion: '116 m2' }, { id: 3, descripcion: '70m2 cubiertos + 46m2 de deck' }]
    },
    {
        id: 2,
        nombre: 'Casa Río II',
        subtitulo: '',
        descripcion: `Ubicación: Río Santiago, Ensenada
        Ejecución: 2 meses`,
        valor: 0,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 0, descripcion: '' },
        imagenes: [
            { id: 1, nombre: 'Imagen01', url: imgCasaRio01 },
            { id: 2, nombre: 'Imagen02', url: imgCasaRio02 },
            { id: 3, nombre: 'Imagen03', url: imgCasaRio03 },
            { id: 4, nombre: 'Imagen04', url: imgCasaRio04 },
            { id: 5, nombre: 'Imagen05', url: imgCasaRio05 },
            { id: 6, nombre: 'Imagen06', url: imgCasaRio06 },
            { id: 7, nombre: 'Imagen07', url: imgCasaRio07 },
            { id: 8, nombre: 'Imagen08', url: imgCasaRio08 },
            { id: 9, nombre: 'Imagen09', url: imgCasaRio09 }
        ],
        caracteristicas: [{ id: 1, descripcion: '2 dormitorios | 6 módulos' }, { id: 2, descripcion: '116 m2' }, { id: 3, descripcion: '70m2 cubiertos + 46m2 de deck' }]
    },
    {
        id: 3,
        nombre: 'Cabañas de mar',
        subtitulo: 'Glamping',
        descripcion: `Ubicación: Mar de las pampas
        Ejecución: 2.5 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Glamping' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgCabañas01 }, { id: 2, nombre: 'Imagen02', url: imgCabañas02 }, { id: 3, nombre: 'Imagen03', url: imgCabañas03 }, { id: 4, nombre: 'Imagen04', url: imgCabañas04 },
        { id: 5, nombre: 'Imagen05', url: imgCabañas05 }, { id: 6, nombre: 'Imagen06', url: imgCabañas06 }, { id: 7, nombre: 'Imagen07', url: imgCabañas07 }, { id: 8, nombre: 'Imagen08', url: imgCabañas08 },
        { id: 9, nombre: 'Imagen09', url: imgCabañas09 }, { id: 10, nombre: 'Imagen10', url: imgCabañas10 }],
        caracteristicas: [{ id: 1, descripcion: '2 dormitorios | 6 módulos' }, { id: 2, descripcion: '116 m2' }, { id: 3, descripcion: '70m2 cubiertos + 46m2 de deck' }]
    },
    {
        id: 4,
        nombre: 'Casa Matheu',
        subtitulo: 'Residencial',
        descripcion: `Ubicación: Matheu
        Ejecución: 2.5 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Residencial' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgMatheu01 }, { id: 2, nombre: 'Imagen02', url: imgMatheu02 }, { id: 3, nombre: 'Imagen03', url: imgMatheu03 }, { id: 4, nombre: 'Imagen04', url: imgMatheu04 },
        { id: 5, nombre: 'Imagen05', url: imgMatheu05 }, { id: 6, nombre: 'Imagen06', url: imgMatheu06 }, { id: 7, nombre: 'Imagen07', url: imgMatheu07 }, { id: 8, nombre: 'Imagen08', url: imgMatheu08 },
        { id: 9, nombre: 'Imagen09', url: imgMatheu09 }, { id: 10, nombre: 'Imagen10', url: imgMatheu10 }, { id: 11, nombre: 'Imagen11', url: imgMatheu11 },
        { id: 12, nombre: 'Imagen12', url: imgMatheu12 }, { id: 13, nombre: 'Imagen13', url: imgMatheu13 }
        ],
        caracteristicas: [{ id: 1, descripcion: '1 Dormitorio | 53m2' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 5,
        nombre: 'Guest',
        subtitulo: 'Residencial',
        descripcion: `Ubicación: Gonnet
        Ejecución: 2 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Residencial' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgGuest01 }, { id: 2, nombre: 'Imagen02', url: imgGuest02 }, { id: 3, nombre: 'Imagen03', url: imgGuest03 }, { id: 4, nombre: 'Imagen04', url: imgGuest04 },
        { id: 5, nombre: 'Imagen05', url: imgGuest05 }, { id: 6, nombre: 'Imagen06', url: imgGuest06 }, { id: 7, nombre: 'Imagen07', url: imgGuest07 }, { id: 8, nombre: 'Imagen08', url: imgGuest08 },
        { id: 9, nombre: 'Imagen09', url: imgGuest09 }, { id: 10, nombre: 'Imagen10', url: imgGuest10 }, { id: 11, nombre: 'Imagen11', url: imgGuest11 },
        { id: 12, nombre: 'Imagen12', url: imgGuest12 }, { id: 13, nombre: 'Imagen13', url: imgGuest13 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Casa 1 dormitorio | 97m2' }, { id: 2, descripcion: 'Personalizable' }]
    },
    {
        id: 6,
        nombre: 'Sueño Joven',
        subtitulo: 'Vivienda',
        descripcion: `Ubicación: Villa Castells
        Ejecución: 3 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Vivienda' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgSueño01 }, { id: 2, nombre: 'Imagen02', url: imgSueño02 }, { id: 3, nombre: 'Imagen03', url: imgSueño03 }, { id: 4, nombre: 'Imagen04', url: imgSueño04 },
        { id: 5, nombre: 'Imagen05', url: imgSueño05 }, { id: 6, nombre: 'Imagen06', url: imgSueño06 }, { id: 7, nombre: 'Imagen07', url: imgSueño07 }, { id: 8, nombre: 'Imagen08', url: imgSueño08 },
        { id: 9, nombre: 'Imagen09', url: imgSueño09 }, { id: 10, nombre: 'Imagen10', url: imgSueño10 }, { id: 11, nombre: 'Imagen11', url: imgSueño11 }, { id: 12, nombre: 'Imagen12', url: imgSueño12 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    },
    {
        id: 7,
        nombre: 'Vino Andino',
        subtitulo: 'Alquiler temporario',
        descripcion: `Ubicación: Valle de uco
        Ejecución: 3 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Alquiler temporario' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgVino01 }, { id: 2, nombre: 'Imagen02', url: imgVino02 }, { id: 3, nombre: 'Imagen03', url: imgVino03 }, { id: 4, nombre: 'Imagen04', url: imgVino04 },
        { id: 5, nombre: 'Imagen05', url: imgVino05 }, { id: 6, nombre: 'Imagen06', url: imgVino06 }, { id: 7, nombre: 'Imagen07', url: imgVino07 }, { id: 8, nombre: 'Imagen08', url: imgVino08 },
        { id: 9, nombre: 'Imagen09', url: imgVino09 }, { id: 10, nombre: 'Imagen10', url: imgVino10 }, { id: 11, nombre: 'Imagen11', url: imgVino11 }, { id: 12, nombre: 'Imagen12', url: imgVino12 },
        { id: 13, nombre: 'Imagen13', url: imgVino13 }, { id: 14, nombre: 'Imagen14', url: imgVino14 }, { id: 15, nombre: 'Imagen15', url: imgVino15 }, { id: 16, nombre: 'Imagen16', url: imgVino16 },
        { id: 17, nombre: 'Imagen17', url: imgVino17 }, { id: 18, nombre: 'Imagen18', url: imgVino18 }, { id: 19, nombre: 'Imagen19', url: imgVino19 }, { id: 20, nombre: 'Imagen20', url: imgVino20 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    }
    ,
    {
        id: 8,
        nombre: 'Gala',
        subtitulo: 'Residencial',
        descripcion: `Ubicación: Bariloche
        Ejecución: 2.5 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Residencial' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgGala01 },
        { id: 2, nombre: 'Imagen02', url: imgGala02 }, { id: 3, nombre: 'Imagen03', url: imgGala03 }, { id: 4, nombre: 'Imagen04', url: imgGala04 },
        { id: 5, nombre: 'Imagen05', url: imgGala05 }, { id: 6, nombre: 'Imagen06', url: imgGala06 }, { id: 7, nombre: 'Imagen07', url: imgGala07 },
        { id: 8, nombre: 'Imagen08', url: imgGala08 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    },
    {
        id: 9,
        nombre: 'Casa Canario',
        subtitulo: 'Residencial/Alquiler temporario',
        descripcion: `Ubicación: Costa del este
        Ejecución: 3 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Residencial/Alquiler temporario' },
        imagenes: [{ id: 1, nombre: 'Imagen01', url: imgCasaCanario01 }, { id: 2, nombre: 'Imagen02', url: imgCasaCanario02 },
        { id: 3, nombre: 'Imagen03', url: imgCasaCanario03 }, { id: 4, nombre: 'Imagen04', url: imgCasaCanario04 },
        { id: 5, nombre: 'Imagen05', url: imgCasaCanario05 }, { id: 6, nombre: 'Imagen06', url: imgCasaCanario06 },
        { id: 7, nombre: 'Imagen07', url: imgCasaCanario07 }, { id: 8, nombre: 'Imagen08', url: imgCasaCanario08 },
        { id: 9, nombre: 'Imagen09', url: imgCasaCanario09 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    },
    {
        id: 10,
        nombre: 'Head Quarter Graupel',
        subtitulo: 'Oficinas',
        descripcion: `Ubicación: La Plata
        Ejecución: 2 meses`,
        valor: 40000,
        moneda: 'USD$',
        brochure: '',
        categoria: { id: 1, descripcion: 'Oficinas' },
        imagenes: [
            { id: 1, nombre: 'Imagen01', url: imgHeadQuarter01 }, { id: 2, nombre: 'Imagen02', url: imgHeadQuarter02 },
            { id: 3, nombre: 'Imagen03', url: imgHeadQuarter03 }, { id: 4, nombre: 'Imagen04', url: imgHeadQuarter04 },
            { id: 5, nombre: 'Imagen05', url: imgHeadQuarter05 }, { id: 6, nombre: 'Imagen06', url: imgHeadQuarter06 },
            { id: 7, nombre: 'Imagen07', url: imgHeadQuarter07 }, { id: 8, nombre: 'Imagen08', url: imgHeadQuarter08 }
        ],
        caracteristicas: [{ id: 1, descripcion: 'Proyectos personalizados y adaptados según necesidad' }]
    }
]